import styled from 'styled-components'
import { default as VARIABLES } from '../../themes/styles/variables'

// Wrapper
// ============================================================
export const AccordionListStyle = styled.div`
  width: 100%;
  margin-bottom: 20px;
  /* Parent styles
  ------------------------------- */
  .accordion-summary {
    background-color: #e3ebf0;
  }
  .MuiAccordionDetails-root {
    padding: 0px;
  }

  /* Child element styles
  ------------------------------- */
  .title-accordion-summary {
    display: flex;
    flex: 1;
    display: 100%;
    justify-content: space-between;

    .bidding-amount,
    .no {
      color: #4b4acb;
    }
    .bidding-amount {
      margin-right: 10px;
    }
  }

  /* Modifiers
  ------------------------------- */

  /* State
  ------------------------------- */

  /* Media queries
  ------------------------------- */
`
